import { makeActonCreator } from '../util';

export const UPDATE_CURRENT_ARTICLE = 'UPDATE_CURRENT_ARTICLE';

export const updateCurrentArticle = makeActonCreator(UPDATE_CURRENT_ARTICLE);
